import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import { useGroupFilters } from '@app/group/hooks/use-group-filters';
import { usePeriodDateRange } from '@app/group/hooks/use-period-date-range';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetGroupPackaging } from '@shared/api/hooks/group/packaging';
import {
  GroupPackagingListCarbonIntensityCategoryItem,
  GroupPackagingListSortItem,
} from '@shared/api/types';
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';
import GroupPage from '../components/group-page';
import GroupPackagingTable from '../components/tables/group-packaging-table';

export default function GroupPackagingPage() {
  const { page, perPage, sort } = useDataTableQueryState();
  const [name] = useQueryState('name', parseAsString);
  const [rating] = useQueryState(
    'rating',
    parseAsArrayOf(parseAsString).withDefault([])
  );
  const [supplier] = useQueryState(
    'supplier',
    parseAsArrayOf(parseAsString).withDefault([])
  );

  const [{ orgs }] = useGroupFilters();
  const { start, end } = usePeriodDateRange();

  const data = useGetGroupPackaging({
    page,
    page_size: perPage,
    sort: formatMultipleSortingForEndpoint(
      sort ?? []
    ) as GroupPackagingListSortItem[],
    organizations: orgs.length ? orgs : undefined,
    dateStart: start ?? undefined,
    dateEnd: end ?? undefined,
    search: name || undefined,
    carbonIntensityCategory: rating.length
      ? (rating as GroupPackagingListCarbonIntensityCategoryItem[])
      : undefined,
    suppliers: supplier.length ? supplier : undefined,
  });

  const count = data.data?.count ?? 0;
  const pageCount = Math.ceil(count / (perPage || 10));

  if (data.isError) throw new Error('Failed to load group packaging');

  return (
    <GroupPage pageKey="purchasingPackaging">
      <GroupPackagingTable {...data} pageCount={pageCount} />
    </GroupPage>
  );
}
